export const SET_COMPANY = 'SET_COMPANY';
export const ADD_SERVICE_ITEM = 'ADD_SERVICE_ITEM';
export const REMOVE_SERVICE_ITEM = 'REMOVE_SERVICE_ITEM';
export const UPDATE_SERVICE_ITEM = 'UPDATE_SERVICE_ITEM';
export const RESET_STATE = 'RESET_STATE';
export const SET_SERVICE_COURSE = 'SET_SERVICE_COURSE';
